
export const ROLES = {
    client:"client",
    carer:"carer",
    instructor:"instructor",
    coordinator:'coordinator',
    admin:"admin",
    superAdmin:"superAdmin",
}